@if (condition) {
  <div class="cargo-position-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargoOfRoutingPositions"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="cargoposition" name="cargoposition" maxlength="255"
          [maxlength]="255">
        </mat-form-field>
      </div>
    </div>
  }
